import { createReducer } from 'redux-act';
import {
  ACTIVE_MENU, ACTIVE_TAB_INFORMATION,
  ACTIVE_TAB_MEDIA,
  ACTIVE_TAB_TENANT,
  FILTER_CLEAN_UP,
  SET_INFO_CATEGORY,
  SET_POI_CATEGORY,
  SET_POI_FLOOR,
  SET_POI_LINK_FILTER,
  SET_POI_TAG
} from 'state/actions/breadcrumb';

const initialState = {
  list: [{ menu: '', link: '' }],
  media: 'published',
  tenant: 'published',
  information:'published',
  poiCategory: 'all',
  poiTag: 'all',
  poiFloor: 'all',
  poiLinkFilter: 'all',
  infoCategory: 'all',
};

export const breadcrumbReducer = createReducer(
  {
    [ACTIVE_MENU]: (state, payload) => ({
      ...state,
      list: payload.list,
    }),
    [ACTIVE_TAB_MEDIA]: (state, payload) => ({
      ...state,
      media: payload.media,
    }),
    [ACTIVE_TAB_TENANT]: (state, payload) => ({
      ...state,
      tenant: payload.tenant,
    }),
    [ACTIVE_TAB_INFORMATION]: (state, payload) => ({
      ...state,
      information: payload.info,
    }),
    [SET_POI_CATEGORY]: (state, payload) => ({
      ...state,
      poiCategory: payload.data,
    }),
    [SET_POI_TAG]: (state, payload) => ({
      ...state,
      poiTag: payload.data,
    }),
    [SET_POI_FLOOR]: (state, payload) => ({
      ...state,
      poiFloor: payload.data,
    }),
    [SET_POI_LINK_FILTER]: (state, payload) => ({
      ...state,
      poiLinkFilter: payload.data,
    }),
    [SET_INFO_CATEGORY]: (state, payload) => ({
      ...state,
      infoCategory: payload.data,
    }),
    [FILTER_CLEAN_UP]: (state) => ({
      ...state,
      infoCategory: 'all',
      poiCategory: 'all',
      poiTag: 'all',
      poiFloor: 'all',
      poiLinkFilter: 'all',
    }),
  },
  initialState
);
